export const JENJANGS_GET = 'JENJANGS_GET';
export const JENJANG_ADD = 'JENJANG_ADD';
export const JENJANG_EDIT = 'JENJANG_EDIT';
export const JENJANG_GET = 'JENJANG_GET';
export const JENJANG_DELETE = 'JENJANG_DELETE';
